import React from 'react'

export function useHydrated() {
  return React.useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  )
}
function subscribe() {
  return () => {}
}
